import { Info } from 'lucide-react';
import { formatDistanceToNow } from 'date-fns';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';

/** Why the last Auto-categorize run left an item uncategorized, on hover of a small info icon. */
export function CategorizeMissHint({ miss }: { miss?: { reason: string; at: string } | null }) {
  if (!miss?.reason) return null;
  const at = new Date(miss.at);
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <button
          type='button'
          aria-label='Why this was not categorized'
          className='inline-flex shrink-0 text-gray-900 hover:text-foreground'
          onClick={(event) => event.stopPropagation()}
        >
          <Info className='size-3.5' />
        </button>
      </TooltipTrigger>
      <TooltipContent className='max-w-xs'>
        <p className='font-medium'>
          Not categorized{Number.isNaN(at.getTime()) ? '' : ` · ${formatDistanceToNow(at, { addSuffix: true })}`}
        </p>
        <p>{miss.reason}</p>
      </TooltipContent>
    </Tooltip>
  );
}
